import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather";
import { Link } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";


const CustomerRegister = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    emailOtp: "",
    phone: "",
    phoneOtp: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);
const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  // Toggle Password Visibility
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Request OTP for Email
  const getEmailOtp = async () => {
    if (!formData.email.trim()) {
      setErrors((prev) => ({ ...prev, email: "Email is required" }));
      return;
    }
  
    const requestData = { email: formData.email };  
    console.log("Sending Email OTP Request:", requestData); // Log the sent data
  
    try {
      const response = await axios.post(`${baseurl}generateEmailOtp`, requestData);
      console.log("Email OTP Response:", response.data); // Log the response from backend
  
      setEmailOtpSent(true);
      alert("OTP sent to your email.");
    } catch (error) {
      console.error("Email OTP Error", error.response?.data || error);
      alert(error.response?.data?.message || "Failed to send OTP");
    }
  };
  

  // Request OTP for Phone
  const getPhoneOtp = async () => {
    if (!formData.phone.trim()) {
        setErrors((prev) => ({ ...prev, phone: "Phone is required" }));
        return;
    }

    try {
        console.log("Sending phone OTP request with data:", { phone: formData.phone });

        await axios.post(`${baseurl}generatePhoneOtp`, { phone: formData.phone });

        setPhoneOtpSent(true);
        alert("OTP sent to your phone.");
    } catch (error) {
        console.error("Phone OTP Error", error.response?.data || error);
        alert(error.response?.data?.message || "Failed to send OTP");
    }
};

const [isEmailVerified, setIsEmailVerified] = useState(false);
const [isPhoneVerified, setIsPhoneVerified] = useState(false);

const verifyEmailOtp = async () => {
  if (!formData.email.trim() || !formData.emailOtp.trim()) {
    setErrors((prev) => ({
      ...prev,
      emailOtp: "Please enter the OTP for email verification.",
    }));
    return;
  }

  try {
    const response = await axios.post(`${baseurl}verifyEmailOtp`, {
      email: formData.email,
      otp: formData.emailOtp,
    });

    alert(response.data.message);
    setIsEmailVerified(true); // Disable button after success
  } catch (error) {
    console.error("Email OTP Verification Error", error.response?.data || error);
    alert(error.response?.data?.message || "Failed to verify email OTP");
  }
};

const verifyPhoneOtp = async () => {
  if (!formData.phone.trim() || !formData.phoneOtp.trim()) {
    setErrors((prev) => ({
      ...prev,
      phoneOtp: "Please enter the OTP for phone verification.",
    }));
    return;
  }

  try {
    const response = await axios.post(`${baseurl}verifyPhoneOtp`, {
      phone: formData.phone,
      otp: formData.phoneOtp,
    });

    alert(response.data.message);
    setIsPhoneVerified(true); // Disable button after success
  } catch (error) {
    console.error("Phone OTP Verification Error", error.response?.data || error);
    alert(error.response?.data?.message || "Failed to verify phone OTP");
  }
};


  // Form Validation
  const validateForm = () => {
    let errors = {};
    if (!formData.firstName.trim()) errors.firstName = "First Name is required";
    if (!formData.lastName.trim()) errors.lastName = "Last Name is required";
    if (!formData.email.trim()) errors.email = "Email is required";
    if (!emailOtpSent) errors.emailOtp = "Email OTP is required";
    if (!formData.emailOtp.trim()) errors.emailOtp = "Enter the OTP sent to your email";
    if (!formData.phone.trim()) errors.phone = "Phone is required";
    if (!phoneOtpSent) errors.phoneOtp = "Phone OTP is required";
    if (!formData.phoneOtp.trim()) errors.phoneOtp = "Enter the OTP sent to your phone";
    if (!formData.password) errors.password = "Password is required";
    if (formData.password.length < 6) errors.password = "Password must be at least 6 characters";
    if (formData.password !== formData.confirmPassword) errors.confirmPassword = "Passwords do not match";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

   

    if (!isEmailVerified || !isPhoneVerified) {
      Swal.fire({
        icon: "warning",
        title: "OTP Verification Required",
        text: "Please verify your Email and Phone OTP before submitting the form.",
      });
      return;
    }



    if (!validateForm()) return; // Stop if validation fails

    try {
      const response = await axios.post(`${baseurl}customerRegister`, formData);
      console.log("Registration Successful", response.data);

      const { id, first_name, email, phone } = response.data.data;
      localStorage.setItem("cust_id", id);
      localStorage.setItem("cust_name", first_name);
      localStorage.setItem("cust_email", email);
      localStorage.setItem("cust_phone", phone);

      const dataToEncode = JSON.stringify({ email, phone, id });
      const encodedData = btoa(dataToEncode);
      // navigate(`/verifyotp?data=${encodeURIComponent(encodedData)}`);
      navigate(`/`);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        emailOtp: "",
        phone: "",
        phoneOtp: "",
        password: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.error("Registration Error", error.response?.data || error);
      alert(error.response?.data?.message || "Registration failed");
    }
  };

  return (
    <>
      <VisitorNavbar />
      <div>
        <section className="mb-5">
          <div className="container">
            <div className="row g-2 my-3 justify-content-center">
              <div className="col-md-7">
                <div className="reviewcls">
                  <h4 className="review-form-heading">Create an Account</h4>
                  <p className="payttl">Please register by filling out the information below.</p>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label className="form-label">First Name <span className="text-danger">*</span></label>
                        <input type="text" name="firstName" className="form-control" placeholder="Enter your first name" value={formData.firstName} onChange={handleChange} />
                        {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Last Name <span className="text-danger">*</span></label>
                        <input type="text" name="lastName" className="form-control" placeholder="Enter your last name" value={formData.lastName} onChange={handleChange} />
                        {errors.lastName && <small className="text-danger">{errors.lastName}</small>}
                      </div>

                   
 
    <div className="col-md-6">
      <label className="form-label">
        Email Address <span className="text-danger">*</span>
      </label>
      <div className="input-group">
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
          disabled={isEmailVerified} // Disable input if verified
        />
        <button
          type="button"
          className="btn btn-secondary"
          onClick={getEmailOtp}
          disabled={isEmailVerified} // Disable button if verified
        >
          Get OTP
        </button>
      </div>
      {errors.email && <small className="text-danger">{errors.email}</small>}

      <input
        type="text"
        name="emailOtp"
        className="form-control mt-2"
        placeholder="Enter Email OTP"
        value={formData.emailOtp}
        onChange={handleChange}
        disabled={isEmailVerified} // Disable input if verified
      />
      {errors.emailOtp && <small className="text-danger">{errors.emailOtp}</small>}

      <span
        type="button"
        className={`vtgy mt-2 ${isEmailVerified ? "vtgysuccess" : "vtgy"}`}
        onClick={verifyEmailOtp}
        disabled={isEmailVerified} // Disable button after verification
      >
        {isEmailVerified ? "Email OTP Verified ✅" : "Verify Email OTP"}
      </span>
    </div>

    <div className="col-md-6">
      <label className="form-label">
        Phone <span className="text-danger">*</span>
      </label>
      <div className="input-group">
        <input
          type="number"
          name="phone"
          className="form-control"
          placeholder="Enter your phone"
          value={formData.phone}
          onChange={handleChange}
          disabled={isPhoneVerified} // Disable input if verified
        />
        <button
          type="button"
          className="btn btn-secondary"
          onClick={getPhoneOtp}
          disabled={isPhoneVerified} // Disable button if verified
        >
          Get OTP
        </button>
      </div>
      {errors.phone && <small className="text-danger">{errors.phone}</small>}

      <input
        type="text"
        name="phoneOtp"
        className="form-control mt-2"
        placeholder="Enter Phone OTP"
        value={formData.phoneOtp}
        onChange={handleChange}
        disabled={isPhoneVerified} // Disable input if verified
      />
      {errors.phoneOtp && <small className="text-danger">{errors.phoneOtp}</small>}

      <span
        type="button"
        className={`vtgy mt-2 ${isPhoneVerified ? "vtgysuccess" : "vtgy"}`}
        onClick={verifyPhoneOtp}
        disabled={isPhoneVerified} // Disable button after verification
      >
        {isPhoneVerified ? "Phone OTP Verified ✅" : "Verify Phone OTP"}
      </span>
    </div>

                    </div>

                    {/* Password */}
                    <div className="col-12">
                        <label htmlFor="password" className="form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            className="form-control"
                            placeholder="Enter your password"
                            value={formData.password}
                            onChange={handleChange}
                          />
                          <span
                            className="input-group-text"
                            onClick={togglePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <EyeOff /> : <Eye />}
                          </span>
                        </div>
                        {errors.password && <small className="text-danger">{errors.password}</small>}
                      </div>

                      {/* Confirm Password */}
                      <div className="col-12">
                        <label htmlFor="confirmPassword" className="form-label">
                          Confirm Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirmPassword"
                            name="confirmPassword"
                            className="form-control"
                            placeholder="Confirm your password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                          />
                          <span
                            className="input-group-text"
                            onClick={toggleConfirmPasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showConfirmPassword ? <EyeOff /> : <Eye />}
                          </span>
                        </div>
                        {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
                      </div>

                      
                      <div class="form-check mt-3">
  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" required />
  <label class="form-check-label" for="flexCheckDefault">
    I have read and agree to the <a href="/terms-and-conditions" target="_blank">Terms and Conditions</a>.
  </label>
</div>


                    <div className="mt-3">
                      <button type="submit" className="btn submitbtnn w-100">Register</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default CustomerRegister;
